import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ImpressionList } from '../assets/list/ImpressionList'
import Footer from '../components/footer'
import btnAssessment2 from '../assets/images/btn_assessment_2.png'
const Impression = () => {
  const [isChecked, setIsChecked] = useState(false)
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
  const [val, setVal] = useState(Array<string>);
  const navigate = useNavigate()

  useEffect(() => {
    setIsSubmitDisabled(true)
    if (!isChecked) return
    setIsSubmitDisabled(false)
  }, [isChecked])

  const onChangeCheckbox = (e: { target: { value: any } }) => {
    if (!isChecked) {
      if (val.includes(e.target.value))
      setIsChecked(!isChecked)
      setIsSubmitDisabled(false)
    }
    setVal([...val, e.target.value]);
  }
  const handleSave = () => {
    localStorage.setItem("impression", String(val));
    navigate('/nanineko/assessment?p=1')
    setIsChecked(!isChecked)
  }
  return (
    <div className="impression">
      <p className="impression-sub-text">診断をはじめる前にちょっと質問！</p>
      <div className="impression_text anime_poyon">
        <h2>あなたの猫さんは、どんな性格ですか？</h2>
      </div>
      <p style={{textAlign:'center',marginBottom:'0'}}>※複数選択できます</p>
      <form >
        {ImpressionList.map((impression) =>
        <span className="impression-list">
          <input 
            type="checkbox" 
            name={ impression } 
            value={ impression } 
            id={ impression } 
            onChange={ onChangeCheckbox }
          />
          <label htmlFor={ impression }>{impression}</label></span>
        )}
        <input type="checkbox" id="F" className="btn_imp" disabled={isSubmitDisabled}/>
        <label className="btn_impression" htmlFor="F"></label>
        <div className="G anime_fadein_short">
          <label className="btn_impression_after"></label>
            <button className="btn_assessment2" onClick={handleSave}>
              <img src={ btnAssessment2 } />
            </button>
        </div>
      </form>
      <Footer />
    </div>
  )
}
  
  export default Impression